import { Table, Typography } from 'antd';
import { TaxLine } from 'store/invoices/types';
import { StyledInvoicesTableWrapper } from 'views/invoices/settings/styles';

type Props = {
    taxLines: TaxLine[];
};

const TaxLinesTable = ({ taxLines }: Props) => {
    return (
        <StyledInvoicesTableWrapper>
            <Table<TaxLine>
                columns={[
                    {
                        title: 'Quantity',
                        dataIndex: 'quantity',
                        key: 'quantity',
                        width: 60,
                        align: 'right',
                        render: (quantity: number) => {
                            const dataTestId = 'quantity-row';
                            return <Typography data-testid={dataTestId}>{quantity}</Typography>;
                        },
                    },
                    {
                        title: 'Description',
                        dataIndex: 'description',
                        key: 'description',
                        render: (text: string) => {
                            const dataTestId = 'description-row';
                            return <Typography.Text data-testid={dataTestId}>{text}</Typography.Text>;
                        },
                    },
                    {
                        title: 'Price',
                        key: 'price',
                        dataIndex: 'unitPrice',
                        align: 'right',
                        width: 120,
                        render: (_unitPrice: number, record) => {
                            const dataTestId = 'price-row';
                            const value = record.unitPrice ?? 0;
                            return <Typography.Text data-testid={dataTestId}>{value}</Typography.Text>;
                        },
                    },
                    {
                        title: 'Net Amount',
                        dataIndex: 'netAmount',
                        key: 'netAmount',
                        align: 'right',
                        width: 120,
                        render: (_, record) => {
                            const dataTestId = 'netAmount-row';
                            const value = record.netAmount ?? 0;
                            return <Typography.Text data-testid={dataTestId}>{value?.toFixed(2)}</Typography.Text>;
                        },
                    },
                    {
                        title: 'Tax Rate %',
                        dataIndex: 'taxPercent',
                        key: 'taxPercent',
                        align: 'right',
                        width: 120,
                        render: (_, _record) => {
                            const dataTestId = 'taxRate-row';
                            return (
                                <Typography.Text data-testid={dataTestId}>
                                    {_record.taxPercent?.toFixed(2)}
                                </Typography.Text>
                            );
                        },
                    },
                    {
                        title: 'Tax Amount',
                        dataIndex: 'taxAmount',
                        key: 'taxAmount',
                        align: 'right',
                        width: 120,
                        render: (_, _record) => {
                            const dataTestId = 'taxAmount-row';
                            return (
                                <Typography.Text data-testid={dataTestId}>
                                    {_record.taxAmount?.toFixed(2)}
                                </Typography.Text>
                            );
                        },
                    },
                ]}
                dataSource={taxLines}
                pagination={false}
                bordered={false}
                size="small"
                rowKey="key"
            />
        </StyledInvoicesTableWrapper>
    );
};

export default TaxLinesTable;
